import template from './jobsFilter.template.html';

export default {
  template,
  bindings: {
    filters: '<',
    jobTypes: '<',
    jobProgresses: '<',
    accounts: '<',
    workflows: '<',
    tickets: '<',
    onApplied: '&',
    onClosed: '&'
  },
  controller: class controller {
    constructor(
      $rootScope,
      $timeout,
      actionService,
      Filter,
      FilterType,
      filterService,
      filtersService,
      contactsService,
      dateTimeService,
      searchService,
      JobProgress,
      uiService,
      JOB,
      CONTACT
    ) {
      'ngInject';
      /*
       * Controller model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.model = {};
      ctrl.currentDateFormat = $rootScope.CurrentDateFormatPrimary();
      ctrl.filtersList = null;
      ctrl.hasSelection = false;
      ctrl.isEditing = false;
      ctrl.isVisible = false;
      ctrl.isReady = true;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.initialize = () => {
        ctrl.filters = ctrl.filters || [];
        ctrl.jobTypes = ctrl.jobTypes || [];
        ctrl.jobProgresses = JobProgress.available() || [];
        ctrl.accounts = ctrl.accounts || [];
        ctrl.workflows = ctrl.workflows || [];
        ctrl.tickets = ctrl.tickets || [];

        ctrl.isVisible = true;
      };

      ctrl.listChange = (list, data, isSelected) => {
        ctrl.hasSelection = isSelected || list.isSelectedAny();
      };

      ctrl.listReady = (list) => {
        ctrl.filtersList = list;
      };

      ctrl.operatorToggle = (prop) => {
        ctrl.model[prop].operatorNot = !ctrl.model[prop].operatorNot;
      };

      ctrl.operatorClass = (prop) => ({
        'fab-red-hover': ctrl.model[prop].operatorNot === true,
        'fab-green-hover': ctrl.model[prop].operatorNot === false
      });

      ctrl.filterEdit = ($event, filter) => {
        $event.stopPropagation();
        ctrl.isEditing = true;
        ctrl.filter = filter || Filter.blank();

        // Init Filter model with Template
        ctrl.model = filterService.modelCompose(ctrl.filter, JOB.FILTERS);

        // Remap Name back to Model
        ctrl.model.name =
          _.get(ctrl.filter, 'name') || `Task filter ${ctrl.filters.length + 1}`;

        // Remap Contact ID's back to Chips
        if (ctrl.model.CONTACT.values.length) {
          contactsService
            .getSpecific({
              idContacts: ctrl.model.CONTACT.values,
              isActive: true,
              fields: CONTACT.FIELDS.WTF_LIST
            })
            .then((contacts) => {
              ctrl.model.CONTACT.values = _.map(contacts, (c) => ({
                id: c.id,
                name: c.getName(),
                phone: c.getPhone(),
                email: c.getEmail()
              }));
            });
        }

        dateTimeService.getSet(ctrl, ctrl.model.DUE_DATE, 'values[0]', 'getSetDueDateFrom');
        if (ctrl.model.DUE_DATE.values[0]) {
          ctrl.getSetDueDateFrom(
            moment.utc(ctrl.model.DUE_DATE.values[0], 'X').format('YYYY-MM-DD')
          );
        }
        dateTimeService.getSet(ctrl, ctrl.model.DUE_DATE, 'values[1]', 'getSetDueDateTo');
        if (ctrl.model.DUE_DATE.values[1]) {
          ctrl.getSetDueDateTo(
            moment.utc(ctrl.model.DUE_DATE.values[1], 'X').format('YYYY-MM-DD')
          );
        }
      };

      ctrl.filterApply = ($event, filterToApply, isList) => {
        $event.stopPropagation();

        if (isList) {
          ctrl.onApplied({
            idFilter: filterToApply.id,
            filterName: filterToApply.name
          });
          ctrl.isReady = false;
          return;
        }

        ctrl.filter.type = FilterType.job;
        ctrl.filter.name = ctrl.model.name || `Task filter ${ctrl.filters.length + 1}`;
        ctrl.filter.items = filterService.modelDecompose(ctrl.model);

        if (_.isEmpty(ctrl.filter.id)) {
          filterService.createFilter(ctrl.filter).then((data) => {
            if (data.status) {
              ctrl.onApplied({ idFilter: data.id, filterName: ctrl.filter.name });
              ctrl.isReady = false;
            } else {
              uiService.toast({
                text: {
                  p1: 'Failed to',
                  p2: 'save',
                  p3: 'your changes'
                },
                warn: true
              });
            }
          });
        } else {
          filterService.updateFilter(ctrl.filter).then((data) => {
            if (data.status) {
              ctrl.onApplied({ idFilter: ctrl.filter.id, filterName: ctrl.filter.name });
              ctrl.isReady = false;
            } else {
              uiService.toast({
                text: {
                  p1: 'Failed to',
                  p2: 'save',
                  p3: 'your changes'
                },
                warn: true
              });
            }
          });
        }
      };

      ctrl.filterDelete = () => {
        filtersService.clearCache();
        actionService
          .deleteDocuments(
            ctrl.filtersList.getSelected(),
            filterService.deleteFilter,
            ctrl.filtersList.removeData,
            'filter(s)'
          )
          .then(() => {
            ctrl.hasSelection = false;
          });
      };

      ctrl.filterDuplicate = () => {
        filtersService.clearCache();
        actionService
          .duplicateDocuments(
            ctrl.filtersList.getSelected(),
            filterService.readFilter,
            filterService.createFilter,
            ctrl.filtersList.setDataAppend,
            'name',
            ' copy',
            'filter(s)'
          )
          .then(() => {
            ctrl.hasSelection = false;
          });
      };

      ctrl.filterClose = () => {
        ctrl.isReady = false;
        ctrl.onClosed();
      };

      ctrl.filterCancel = ($event) => {
        $event.stopPropagation();
        ctrl.isEditing = false;
      };

      ctrl.contactSearch = (query) => searchService.getContacts({ query });

      ctrl.contactMapToChip = (chip) => (angular.isObject(chip) ? chip : { value: chip });

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      ctrl.$onInit = () => {
        $timeout(() => {
          ctrl.initialize();
        }, 250);
      };
    }
  }
};
